import React from 'react'
import PropTypes from 'prop-types'

import { labels } from 'utils/whitelabel'

const apiKey = 'd28f22eb-fc21-4889-b230-672b7ee4f533'

export const UsersnapContext = React.createContext(null)

export const UsersnapProvider = ({ initParams = {}, children }) => {
  const [usersnapApi, setUsersnapApi] = React.useState(null)

  React.useEffect(() => {
    if (import.meta.env.REACT_APP_ENVIRONMENT_NAME === 'production' && labels.name === 'Jisr') {
      window.onUsersnapCXLoad = (api) => {
        api.init(initParams)
        setUsersnapApi(api)
        window.usersnapApi = api
      }
      const script = document.createElement('script')
      script.defer = 1
      script.src = `https://widget.usersnap.com/global/load/${apiKey}?onload=onUsersnapCXLoad`
      document.head.appendChild(script)

      return () => {
        if (usersnapApi) {
          usersnapApi.destroy()
        }
        script.remove()
      }
    }
    return null
  }, [])

  return <UsersnapContext.Provider value={usersnapApi}>{children}</UsersnapContext.Provider>
}

UsersnapProvider.propTypes = {
  initParams: PropTypes.shape(),
  children: PropTypes.node,
}

export const useUsersnapApi = () => React.useContext(UsersnapContext)
